/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";
import { Info, TriangleAlert } from "lucide-react";
import { Button } from "../ui/button";
import MMTCLOGO from "../../icons/MMTCLOGO.svg";
import VectorTopRight from "../../icons/VectorTopRight.svg";
import VectorBottomLeft from "../../icons/VectorBottomLeft.svg";

const NextStepsSection = () => {
  return (
    <div className='w-full bg-[#EBEFFF] border border-[#3861FB3D] rounded-xl p-4 flex gap-2'>
      <div className='w-5 h-5 flex-shrink-0'>
        <Info color='#3861FB' className='w-5 h-5' />
      </div>
      <div className='flex flex-col gap-1'>
        <h4 className='text-sm font-medium text-[#262626]'>Next Steps:</h4>
        <ol className='text-sm text-[#262626] list-decimal list-inside flex flex-col gap-1'>
          <li>Click on “Reselect Account” button below.</li>
          <li>
            While selecting accounts, don’t select the duplicate accounts marked
            above.
          </li>
        </ol>
      </div>
    </div>
  );
};

const DuplicateAccountTable = ({ duplicateAssets = [] }) => {
  return (
    <div className='w-full flex flex-col gap-3'>
      <div className='flex items-center gap-2'>
        <div className='w-5 h-5 flex items-center justify-center'>
          {/* <AlertIcon className='w-full h-full text-[#DA1E28]' /> */}
          <TriangleAlert className='w-full h-full' color="#DA1E28" />
        </div>
        <span className='text-sm font-medium text-[#DA1E28]'>
          Already Linked
        </span>
      </div>

      <div className='border border-[#D9D9D9] rounded-xl overflow-hidden'>
        <div className='bg-[#E8E2D8] flex px-5 py-2 border-b border-[#D9D9D9]'>
          <span className='w-[200px] text-sm font-semibold text-[#595959]'>
            Account Number
          </span>
          <span className='flex-1 text-sm font-semibold text-[#595959]'>
            Asset Type
          </span>
        </div>
        <div className='flex flex-col'>
          {duplicateAssets.length > 0 ? (
            duplicateAssets.map((account, index) => {
              const isLast = index === duplicateAssets.length - 1;
              return (
                <div
                  key={account.accountMask || account.mask || index}
                  className={`flex px-5 py-3 bg-white ${
                    !isLast ? "border-b border-[#D9D9D9]" : ""
                  }`}
                >
                  <span className='w-[200px] text-sm text-[#262626]'>
                    •••• •••• {account.accountMask || "XXXX"}
                  </span>
                  <span className='w-[160px] text-sm text-[#262626] capitalize'>
                    {account.subtype || "N/A"}
                  </span>
                </div>
              );
            })
          ) : (
            <div className='flex px-5 py-3 bg-white'>
              <span className='text-sm text-[#999999]'>
                No duplicate accounts details available.
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const DuplicatePlaidAccountsScreen = ({ duplicateAssets = [] }) => {
  return (
    <div className='min-h-screen bg-white flex flex-col items-center relative overflow-hidden font-sans'>
      {/* Background Decorative Vectors */}
      <VectorTopRight className='absolute top-0 right-0 pointer-events-none' />
      <VectorBottomLeft className='absolute bottom-0 left-0 pointer-events-none' />

      <div className='flex flex-col items-center pt-[70px] z-10'>
        <MMTCLOGO className='w-[148px] h-[49px]' />
      </div>

      <div className='flex flex-col items-center mt-14 z-10 w-full px-4 pb-20'>
        <div className='w-full max-w-[640px] bg-white border border-[#F0F0F0] rounded-2xl shadow-[0px_4px_14px_rgba(0,0,0,0.12)] flex flex-col'>
          {/* Header Section */}
          <div className='flex items-center gap-4 px-6 pt-6'>
            <div className='w-16 h-16 flex-shrink-0 flex items-center justify-center bg-[#FDEBEC] rounded-xl'>
              {/* <AlertIcon className='w-8 h-8 text-[#DA1E28]' /> */}
              <TriangleAlert className='w-8 h-8' color="#DA1E28" />
            </div>
            <h2 className='text-2xl font-semibold text-[#262626] leading-tight'>
              This account has already been linked.
            </h2>
          </div>

          {/* Main Content */}
          <div className='flex flex-col gap-4 p-6'>
            <p className='text-base text-[#595959]'>
              The accounts you are attempting to add are already associated with
              this loan. Duplicate accounts cannot be added.
            </p>

            <div className='flex flex-col gap-3'>
              <DuplicateAccountTable duplicateAssets={duplicateAssets} />
              <NextStepsSection />
            </div>
          </div>

          {/* Footer Section */}
          <div className='flex items-center justify-between p-6 border-t border-[#F0F0F0]'>
            <p className='text-sm text-[#595959] max-w-[291px] leading-6'>
              You may close the browser at any time if you choose not to
              proceed.
            </p>
            <Button
              className='px-4 py-2.5 bg-secondary-2 hover:bg-secondary-1 text-white rounded-[10px] text-sm font-medium border-none'
              onClick={() => {
                window.location.reload();
              }}
            >
              Reselect Account
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

DuplicatePlaidAccountsScreen.propTypes = {
  duplicateAssets: PropTypes.array
};
